/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { ADD_NOTE } from "./actionTypes"
import { addNoteError, addNoteSuccess } from "./actions"

//Include Both Helper File with needed methods
import { insertNote } from "../../../helpers/backend_helper"

function* add(action) {
  try {
    const response = yield call(insertNote, action.payload)
    if (response === undefined) throw new Error("API error")
    else yield put(addNoteSuccess(response))
  } catch (error) {
    yield put(addNoteError(error.message))
  }
}

function* noteAddSaga() {
  yield takeEvery(ADD_NOTE, add)
}

export default noteAddSaga
